import { render, staticRenderFns } from "./Droppable.vue?vue&type=template&id=2564cc83&scoped=true"
import script from "./Droppable.vue?vue&type=script&lang=js"
export * from "./Droppable.vue?vue&type=script&lang=js"
import style0 from "./Droppable.vue?vue&type=style&index=0&id=2564cc83&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564cc83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2564cc83')) {
      api.createRecord('2564cc83', component.options)
    } else {
      api.reload('2564cc83', component.options)
    }
    module.hot.accept("./Droppable.vue?vue&type=template&id=2564cc83&scoped=true", function () {
      api.rerender('2564cc83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Droppable.vue"
export default component.exports